import { Checkbox, alpha, styled } from "@mui/material";
import { IStyledCheckboxProps } from "./types";

const pickColor = (theme: any) => ({
    primary: theme?.palette?.primary?.main,
    secondary: theme?.palette?.secondary?.main,
    tertiary: theme?.palette?.tertiary?.main,
    neutral: theme?.palette?.neutral?.main,
    accentInfo: theme?.palette?.accentInfo?.main,
    accentSuccess: theme?.palette?.accentSuccess?.main,
    accentWarning: theme?.palette?.accentWarning?.main,
    accentError: theme?.palette?.accentError?.main,
});

const StyledCheckbox = styled(Checkbox, {
    shouldForwardProp: prop => prop !== "customColor"
})<IStyledCheckboxProps>(({ theme, customColor = "primary" }) => {
    const paletteColor = pickColor(theme)[customColor] ?? (theme as any).palette?.primary?.main;
    const neutral = (theme as any).palette?.neutral;

    return {
        color: neutral?.light ?? paletteColor,
        borderColor: neutral?.light ?? paletteColor,
        padding: (theme as any).spacing?.(0.5) ?? 4,
        transition: "all 120ms ease-out",
        "&:hover": {
            backgroundColor: alpha(paletteColor, 0.08),
        },
        "&.Mui-checked": {
            color: paletteColor,
        },
        "&.MuiCheckbox-indeterminate": {
            color: paletteColor,
        },
        "&.Mui-disabled": {
            color: neutral?.dark ?? paletteColor,
        },
    };
});

export { StyledCheckbox };
